import "./AllTransferOutRequest.css";

import React, { useEffect, useState } from "react";

import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import { getAllTransferOutRequests } from "Config/API/get";
import useFullPageLoader from "Hooks/useFullPageLoader";

const DONE_TYPING_INTERVAL = 1500;

const STATUS_COLOR = {
  pending: "#E8B81A",
  approved: "#5CA127",
  rejected: "#CB1212",
};

const CREDITS_STYLE = { color: "#5CA127", fontWeight: "bold" };

const COLUMNS = [
  { label: "DATE", render: (curr) => curr?.dateTime },
  {
    label: "REQUEST ID",
    width: "20.2%",
    render: (curr) => curr?.transferUid,
  },
  {
    label: "TRANSACTION ID",
    width: "20.2%",
    render: (curr) => curr?.trn_no,
  },
  { label: "COMMENT", width: "35.2%", render: (curr) => curr?.comment },
  {
    label: "CREDITS",
    contentStyle: CREDITS_STYLE,
    render: (curr) => curr?.credit,
  },
  {
    label: "STATUS",
    render: (curr) => (
      <label style={{ backgroundColor: STATUS_COLOR[curr?.status] }}>
        {curr?.status}
      </label>
    ),
  },
];

const AllTransferOutRequest = () => {
  let typingTimer;
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [requestList, setRequestList] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [filterType, setFilterType] = useState("");

  useEffect(() => {
    setLoader();
    getData(filterType, searchedText);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = (filter, searchKeywords) => {
    getAllTransferOutRequests(token, searchKeywords, filter).then((res) => {
      resetLoader();
      if (res?.status === 200) {
        setRequestList(res?.data?.data);
      }
    });
  };

  const searchData = (value) => {
    setSearchedText(value);
    getData(filterType, value);
  };

  const filterData = (value) => {
    const filter = value === "all" ? "" : value;
    setFilterType(filter);
    getData(filter, searchedText);
  };

  return (
    <>
      <div className="all-transfer-out-request-parent">
        <div className="all-transfer-out-request-header">
          <Headers />
        </div>

        <div className="all-transfer-out-request-navigation">
          <Navigation />
        </div>

        <div className="all-transfer-out-request-main">
          <div className="all-transfer-out-request-wrapper">
            <div className="all-transfer-out-request-heading">
              Transfer Out Request History
            </div>
            <div className="all-transfer-out-request-all-active">
              <div className="all-transfer-out-request-top">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(() => {
                      searchData(e.target.value);
                    }, DONE_TYPING_INTERVAL);
                  }}
                />
                <div>
                  <p>Filter:</p>
                  <select onClick={(e) => filterData(e.target.value)}>
                    <option value="all">All</option>
                    <option value="pending">PENDING</option>
                    <option value="approved">APPROVED</option>
                    <option value="rejected">REJECTED</option>
                  </select>
                </div>
              </div>
              <div className="all-transfer-out-request-bottom">
                <div className="all-transfer-out-request-row-wrapper">
                  {COLUMNS.map(({ label, width }) => (
                    <div
                      key={label}
                      className="all-transfer-out-request-head-row"
                      style={width ? { width } : undefined}
                    >
                      {label}
                    </div>
                  ))}
                </div>
                <div className="all-transfer-out-request-bottom-data">
                  {requestList?.length?.toString() !== "0" ? (
                    requestList?.map((curr, index) => (
                      <div
                        className="all-transfer-out-request-content-wrapper"
                        key={index}
                      >
                        {COLUMNS.map(({ label, width, contentStyle, render }) => (
                          <div
                            key={label}
                            className="all-transfer-out-request-content-row"
                            style={width ? { width } : contentStyle}
                          >
                            {render(curr)}
                          </div>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div className="all-transfer-out-request-msg">
                      No Requests Found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default AllTransferOutRequest;
